<template>
    <modal name="edit-product-modal" @before-open="beforeOpen" :resizable="true" transition="pop-out"
           :width="800"
           :height="760">
        <h4 class="text-center panel-heading">Details voor {{product.dutchTitle}}</h4>
        <form @submit.prevent="editProduct()">
            <div class="row">
                <div class="col-sm-12">
                    <div class="col-sm-6 mb-20">
                        <label>Artikelnummer*</label>
                        <input type="text"
                               class="form-control"
                               required
                               v-model="product.articleNumber">
                    </div>
                    <div class="col-sm-6 mb-20">
                        <label>Prijs*</label>
                        <div class="input-group">
                            <span class="input-group-addon" id="basic-addon1">€</span>
                            <input type="number" min="0" step="0.01" required v-model="product.price" class="form-control">
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-12">
                    <div class="col-sm-6 mb-20">
                        <label>Nederlandse naam*</label>
                        <input type="text"
                               class="form-control"
                               v-model="product.dutchTitle"
                               required>
                    </div>
                    <div class="col-sm-6 mb-20">
                        <label>Franse naam</label>
                        <input type="text"
                               v-model="product.frenchTitle"
                               class="form-control">
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-12">
                    <div class="col-sm-6 mb-20">
                        <label>Nederlandse omschrijving</label>
                        <textarea class="form-control"
                                  rows="8"
                                  v-model="product.dutchDescription"></textarea>
                    </div>
                    <div class="col-sm-6 mb-20">
                        <label>Franse omschrijving</label>
                        <textarea class="form-control"
                                  rows="8"
                                  v-model="product.frenchDescription"></textarea>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-6">
                    <div class="col-sm-12 mb-20">
                        <label>Categorie code*</label>
                        <input type="text" class="form-control" v-model="product.categoryCode" required>
                    </div>
                    <div class="col-sm-12 mb-20">
                        <label>Huidige subgroep</label>
                        <vue-select v-model="product.categoryName" label="dutchTranslation" :options="assignableCategories" @input="setCategory" :clearable="false"></vue-select>
                    </div>
                    <div class="col-sm-12 mb-20">
                        <label>Afbeelding (200 x 200)</label>
                        <input type="file"
                               @change="upload($event.target.files)" accept="image/*">
                    </div>
                </div>
                <div v-if="product.imageLocation" class="col-sm-6 mb-20">
                    <label>Huidige afbeelding</label>
                    <div>
                        <img :src="BACKEND_BASE_URL + '/images/' + product.imageLocation" width="150">
                    </div>
                </div>
                <div v-if="!product.imageLocation" class="col-sm-6 mb-20">
                    <label>Huidige afbeelding</label>
                    <div>
                        <i>Geen afbeelding beschikbaar</i>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-12">
                    <div class="col-sm-4">
                        <button type="submit" class="btn btn-danger">Opslaan</button>
                    </div>
                </div>
            </div>
        </form>
    </modal>
</template>
<script>
    import { mapGetters } from 'vuex'
    import * as types from '../../store/mutation-types'
    import VueSelect from 'vue-select'
    import 'vue-select/dist/vue-select.css';

    export default {
        name: 'EditProduct',
        components: {
            VueSelect
        },
        data() {
            return {
                BACKEND_BASE_URL: process.env.VUE_APP_BACKEND_BASE_URL,
                file: null
            }
        },
        methods: {
            editProduct() {
                let reallocated = false
                if (this.product.categoryName.id && this.product.categoryName.id !== this.product.categoryId) {
                    reallocated = true
                    this.$store.commit(types.SET_CATEGORY_ID_ON_PRODUCT, this.product.categoryName.id)
                }

                this.$store.commit(types.SET_PRODUCT_TO_UPDATE, this.product)
                this.$store.dispatch('editProduct').then(() => {
                    if (this.isProductUpdated) {
                        this.product.category = null
                        this.product.articleNumber = ''
                        this.product.price = 0
                        this.product.dutchTitle = ''
                        this.product.frenchTitle = ''
                        this.product.dutchDescription = ''
                        this.product.frenchDescription = ''
                        this.product.categoryCode = ''
                        this.product.imageLocation = ''

                        if (reallocated) {
                            this.$store.commit(types.REMOVE_PRODUCT_FROM_PRODUCTS, this.product.id)
                        }
                        this.$notify({ group: 'success', type: 'success', title: 'Succes', text: 'Product is aangepast!' })
                        this.$modal.hide('edit-product-modal')
                    }
                })
            },
            beforeOpen(event) {
                if (event.params.productId) {
                    this.$store.dispatch('getProduct', event.params.productId).then(() => {
                        if (this.product.id) {
                            this.$store.dispatch('getAssignableCategories').then(() => {
                                if (this.assignableCategories) {
                                    this.assignableCategories.forEach((assignableCategory) => {
                                        if (this.product.categoryId === assignableCategory.id) {
                                            this.$store.commit(types.SET_CATEGORY_NAME_ON_PRODUCT, assignableCategory)
                                            this.$forceUpdate()
                                        }
                                    })
                                }
                            })
                        }
                    })
                }
            },
            upload(image) {
                let data = new FormData()
                if (image !== '') {
                    this.file = image.item(0)
                    data.append('images', this.file, this.file.name)

                    this.$store.dispatch('uploadImage', data).then(() => {
                        if (this.imageLocation) {
                            this.product.imageLocation = this.imageLocation
                        }
                    })
                }
            },
            setCategory(value) {
                this.$store.commit(types.SET_CATEGORY_NAME_ON_PRODUCT, value)
                this.$forceUpdate()
            }
        },
        computed: {
            ...mapGetters({
                isProductUpdated: 'isProductUpdated',
                imageLocation: 'imageLocation',
                product: 'product',
                assignableCategories: 'assignableCategories'
            }),
            filteredAssignableCategories() {
                return this.assignableCategories.reverse()
            }
        }
    }
</script>

<style scoped>
    .mb-20 {
        margin-bottom: 20px;
    }
</style>
